export const InfoLoader = {
    get: async function() {
        return await new Promise((resolve) => {
            setTimeout(() => {
                resolve({ title: 'This is a scaffold', content: 'Hello World!' });
            }, 1000);
        });
    },
};
